import {from, filter, switchMap} from "rxjs";
import { Injectable } from '@angular/core';
import {
  PopupService
} from "../../../kernel/popups/popup/modules/confirmation-dialog/services/confirmation-popup/popup.service";
import {BlacklistUserPopupComponent} from "../components/blacklist-user-popup/blacklist-user-popup.component";
import {UserApiService} from "./user-api.service";

@Injectable()

export class UserService {
  constructor(
    private popupService: PopupService,
    private userApiService: UserApiService
  ) { }


  blackListUser(id: string) {
    return from(this.openBlackListUserPopup())
      .pipe(
        filter((result) => Boolean(result)),
        switchMap((reasons) => this.userApiService.blackListUser(id))
      )
  }

  openBlackListUserPopup() {
    return this.popupService.open(
      {
        showHeader: false,
        width: '650px',
      },
      BlacklistUserPopupComponent
    )
  }
}
